import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Paper, TextField } from '@material-ui/core';
import i18n from '../../i18n';
import '../../assets/stylesheets/Setting.css';

class StringItemSelector extends Component {
  render() {
    const { required, error, helperText, items, label, onItemChange, selectedItem } = this.props;

    const menuItems = items.map(item => (
      <MenuItem key={item.label} value={item.value}>
        {item.label}
      </MenuItem>
    ));

    return (
      <Paper className="settings-container">
        <TextField
          fullWidth
          required={required}
          error={error}
          select
          label={label}
          value={selectedItem}
          onChange={onItemChange}
          helperText={helperText}
        >
          {menuItems.length ? (
            menuItems
          ) : (
            <MenuItem key={`empty ${label}`}>{i18n.t('empty')}</MenuItem>
          )}
        </TextField>
      </Paper>
    );
  }
}

StringItemSelector.defaultProps = {
  label: i18n.t('settings:chooseOption'),
  helperText: ' ',
  required: false,
  error: false,
};

StringItemSelector.propTypes = {
  helperText: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  ).isRequired,
  label: PropTypes.string,
  onItemChange: PropTypes.func.isRequired,
  selectedItem: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  required: PropTypes.bool,
  error: PropTypes.bool,
};

export default StringItemSelector;
